// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bAfeVE_N6xH2N9eFKWql{right:0;top:3rem;white-space:normal;text-align:start}._Xq7dWPXi80zg3MQLOun{color:var(--brand-purple-50)}", "",{"version":3,"sources":["webpack://./src/code-studio/components/header/sign-in-callout-wrapper.module.scss"],"names":[],"mappings":"AAEA,sBACE,OAAA,CACA,QAAA,CACA,kBAAA,CACA,gBAAA,CAGF,sBACE,4BAAA","sourcesContent":["@import 'breakpoints';\n\n.popover {\n  right: 0;\n  top: 3rem;\n  white-space: normal;\n  text-align: start;\n}\n\n.calloutIcon {\n  color: var(--brand-purple-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": "bAfeVE_N6xH2N9eFKWql",
	"calloutIcon": "_Xq7dWPXi80zg3MQLOun"
};
export default ___CSS_LOADER_EXPORT___;
